import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useRowContext } from './Row';

interface CellProps {
  className?: string;
  children: ReactNode;
}

export const Cell = ({ className, children }: CellProps) => {
  const { rowId, setHoveredRowId, isHovered } = useRowContext();
  return (
    <div
      className={classNames('flex py-1 border-b border-gray-1', className, { 'bg-gray-0': isHovered })}
      data-row-id={rowId}
      onMouseEnter={() => setHoveredRowId(rowId)}
      onMouseLeave={() => setHoveredRowId(null)}
    >
      {children}
    </div>
  );
};
